import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import { configureStore } from "./state/store";
import { awsClient } from "./services";
import { AppContainer } from "./containers";

import "./assets/fonts/fonts.css";

const render = () => {
  awsClient.configure();

  const store = configureStore();

  ReactDOM.render(
    <Provider store={store}>
      <React.StrictMode>
        <AppContainer />
      </React.StrictMode>
    </Provider>,
    document.getElementById("app")
  );
};

render();
